// src/components/GoogleLoginButton.jsx
import React, { useRef, useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { updateProfile } from "../../containers/ProfileSettingsPage/ProfileSettingsPage.duck";
import { apiBaseUrl } from "../../util/api";

const GOOGLE_SCOPES = "https://www.googleapis.com/auth/calendar.events";

const GoogleLoginButton = ({ setValue, booking, listingTitle, attendeesEmails, transactionId, timeZone }) => {
  const googleAccessTokenRef = useRef(null);
  const dispatch = useDispatch();
  const [notification, setNotification] = useState(null); 
    React.useEffect(() => {
    console.log('🔍 Google OAuth Config Check:', {
      hasClientId: !!process.env.REACT_APP_GOOGLE_CLIENT_ID,
      clientIdPrefix: process.env.REACT_APP_GOOGLE_CLIENT_ID?.substring(0, 30),
      env: process.env.REACT_APP_ENV,
      nodeEnv: process.env.NODE_ENV
    });
  }, []);
  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => {
      setNotification(null);
    }, 5000);
  };
  // Helper to create Google Calendar event through our backend
  const createGoogleCalendarEvent = async (accessToken) => {
    console.log('accessToken :>> ', accessToken);
    if (!booking?.id) return; // nothing to create without booking
    
    const bookingData = {
      id: booking.id.uuid,
      title: listingTitle,
      startTime: booking.attributes?.start,
      endTime: booking.attributes?.end,
    };
    try {
      const apiBase = apiBaseUrl(process.env.REACT_APP_MARKETPLACE_ROOT_URL);
console.log('apiBase :>> ', apiBase);
      const res = await fetch(`${apiBase}/api/google/create-event`, {
        method: "POST",
        credentials: 'include',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          access_token: accessToken, 
          booking: bookingData, 
          attendees: attendeesEmails, 
          transactionId,
          timeZone,
        }),
      });
console.log('res :>> ', res);
      const result = await res.json();
      if (!res.ok) {
        // eslint-disable-next-line no-console
        console.error("❌ Calendar sync failed:", result);
        showNotification('error', 'Failed to add event to calendar. Please try again.');
        return false;
      }
      // eslint-disable-next-line no-console
      return true;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("❌ Calendar sync failed:", err);
      showNotification('error', 'Failed to add event to calendar. Please try again.');
      return false;
    }
  };

  const googleLogin = useGoogleLogin({
    scope: GOOGLE_SCOPES,
    onSuccess: async (codeResponse) => {
      const { code } = codeResponse;
      try {
        // Call local Express API (server/apiRouter.js)
        const apiBase = apiBaseUrl(process.env.REACT_APP_MARKETPLACE_ROOT_URL);
                    console.log('apiBase :>> ', apiBase);
                    console.log('process.env.REACT_APP_CLIENT_REDIRECT_URL  :>> ', process.env.REACT_APP_CLIENT_REDIRECT_URL );

//apibase backendcall
        const response = await fetch(`${apiBase}/api/get-refresh-token`, {
          method: "POST",
          credentials: 'include',
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            code,
            // IMPORTANT: redirect_uri must match what GIS used. Default is current origin.
            redirect_uri: process.env.REACT_APP_CLIENT_REDIRECT_URL || window.location.origin,
          }),
        });
 console.log('responsres :>> ', response);
        if (!response.ok) {
          const text = await response.text();
          throw new Error(`HTTP ${response.status}: ${text}`);
        }

        const jsonResponse = await response.json();
        console.log('jsonResponse', jsonResponse);
        
        // Keep a local ref if needed by other features
        googleAccessTokenRef.current = jsonResponse.access_token;

        // Optionally bubble to forms using setValue if provided
        if (typeof setValue === 'function') {
          setValue("access_token", jsonResponse.access_token);
          setValue("access_token_expiry", jsonResponse.expires_in);
          setValue("refresh_token", jsonResponse.refresh_token);
          setValue("refresh_token_expiry", jsonResponse.refresh_token_expires_in);
        }

        // Persist tokens to current user's privateData so that transitions
        // (e.g. Accept booking) can create Google Calendar events.
        const now = Date.now();
        const privateData = {
          googleAccessToken: jsonResponse.access_token,
          googleAccessTokenExpiry: now + (jsonResponse.expires_in || 0) * 1000,
          googleRefreshToken: jsonResponse.refresh_token,
          googleRefreshTokenExpiry: jsonResponse.refresh_token_expires_in
            ? now + jsonResponse.refresh_token_expires_in * 1000
            : undefined,
        };
        dispatch(updateProfile({ privateData }));

        // Immediately create event for the current booking, if available
        if (jsonResponse.access_token) {
          const eventCreated = await createGoogleCalendarEvent(jsonResponse.access_token);
          if (eventCreated) {
            showNotification('success', '🎉 Success! Event added to your Google Calendar');
          }
        } else {
          showNotification('success', '✅ Google Calendar connected successfully');
        }

        console.log("✅ Google login success", jsonResponse);
      } catch (error) {
        console.error("❌ Error exchanging code:", error);
        showNotification('error', 'Failed to connect Google Calendar. Please try again.');
      }
    },
    onError: (error) => {
      console.error("Google login failed:", error);
    },
    // Use auth code flow
    flow: "auth-code",
  });

  return (
    <>
      <style>
        {`
          @keyframes slideInFromRight {
            from {
              transform: translateX(400px);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
      {notification && (
        <div
          style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            padding: '16px 24px',
            background: notification.type === 'success' ? '#4CAF50' : '#F44336',
            color: '#FFFFFF',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 10000,
            fontSize: '16px',
            fontWeight: '500',
            maxWidth: '400px',
            animation: 'slideInFromRight 0.3s ease-out',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          {notification.type === 'success' ? '✅' : '❌'}
          {notification.message}
        </div>
      )}
      <button
        onClick={() => googleLogin()}
        style={{
        height: '48px',
        minWidth: '220px',
        padding: '0 24px',
        margin: '16px 0',
        background: '#FFFFFF',
        color: '#5F6368',
        border: '1px solid #DADCE0',
        borderRadius: '4px',
        fontSize: '16px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        boxShadow: '0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15)',
        ':hover': {
          background: '#F8F9FA',
          boxShadow: '0 1px 3px 0 rgba(60,64,67,0.302), 0 4px 8px 3px rgba(60,64,67,0.149)'
        },
        ':active': {
          background: '#F1F3F4',
          boxShadow: '0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15)'
        },
        ':focus': {
          outline: 'none',
          boxShadow: '0 0 0 2px #E8F0FE',
          borderColor: '#D2E3FC'
        }
      }}
    >
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '12px' }}>
        <path d="M13.5 2.25H14.25C15.075 2.25 15.75 2.925 15.75 3.75V15C15.75 15.825 15.075 16.5 14.25 16.5H3.75C2.925 16.5 2.25 15.825 2.25 15V3.75C2.25 2.925 2.925 2.25 3.75 2.25H4.5V0.75H6V2.25H12V0.75H13.5V2.25ZM14.25 6H3.75V15H14.25V6ZM12 7.5H15V14.25H12V7.5ZM9 7.5V9.75H6V7.5H9Z" fill="#5F6368"/>
      </svg>
      Connect Google Calendar
    </button>
    </>
  );
};

export default GoogleLoginButton;

